module.exports = __webpack_public_path__ + "static/media/favorites-empty-gray.7f7bb814.svg";